<div class="university-card">
  <!-- Logo -->
  <div class="logo">
    <p-avatar
      *ngIf="!imageError && foto; else defaultAvatar"
      [image]="foto"
      shape="circle"
      size="large"
      (onImageError)="imageError = true"
    />
    <ng-template #defaultAvatar>
      <p-avatar
        [label]="getInitials(nome)"
        [icon]="!nome ? 'pi pi-user' : undefined"
        shape="circle"
        size="large"
      />
    </ng-template>
  </div>

  <!-- Name and Description -->
  <div class="details">
    <h3 class="name">{{ nome }}</h3>
    <div class="contact-info">
      <div class="info-item">
        <div class="icon">
        </div>
        <span>{{ idade }} anos de idade</span>
      </div>
    </div>
  </div>

  <div class="extra-info mr-4">
    <div class="info-item">
      <div class="icon">
        <img src="icons/globe-01.svg" alt="Ícone de Website" />
      </div>
      <span class="info">{{ nacionalidade }}</span>
    </div>

    <div class="info-item">
      <div class="icon">
        <img src="icons/graduation-grey.svg" alt="Ícone de Graduação" />
      </div>
      <span> {{ nivelAcademico | nivelAcademico }}</span>
    </div>

    <div class="container-estado ">
      <!-- <div class="estado"
        [ngClass]="{'estado-vinculado': estado === 'activo', 'estado-inativo': estado === 'Inativo'}">
        <span>{{ estado }}</span>
      </div> -->
      <p-tag [value]="estado" [severity]="severity"></p-tag>
    </div>
  </div>

  <!-- Navigation Icon -->
  <div class="navigate" (click)="ShowDetais($event)">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
      <path
        d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
    </svg>


    <div class="details-card">
      <button type="button" (click)="routerLink()">Detalhes</button>
      <button type="button" (click)="GotoAuxForm()" class="d-flex align-items-center flex-row"> <i class="pi pi-arrow-circle-right" style="font-size: 1rem"></i> Atribuir Auxilio de Formação</button>
      <!-- <button type="button" (click)="gerarComprovativo()"><i class="pi pi-download" style="font-size: 1rem"></i> Ficha de cadastro</button> -->
      <!-- <button type="button" (click)="gerarOficio(bolseiro.id)"><i class="pi pi-download" style="font-size: 1rem"></i> Gerar Ofício</button> -->
    </div>
  </div>
</div>
